import React from 'react';
import { translations } from '../utils/translations';

// Helper to generate stable keys from content
const getStableKey = (content, prefix = '') => {
  return `${prefix}-${content.substring(0, 20).replace(/\s+/g, '-')}`;
};

const Privacy = ({ language = 'en' }) => {
  const t = translations[language].privacy;

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="section-container">
          <h1>{t.title}</h1>
          <p className="legal-date">{t.lastUpdated}</p>
        </div>
      </div>

      <div className="legal-content">
        <div className="section-container narrow">
          <section className="legal-section">
            <h2>{t.section1Title}</h2>
            <p>
              {t.section1Content.split('|').map((line) => (
                <React.Fragment key={getStableKey(line, 'section1')}>
                  {line !== t.section1Content.split('|')[0] && <br />}
                  {line.includes('CIF') ? <strong>{line}</strong> : line}
                </React.Fragment>
              ))}
            </p>
          </section>

          <section className="legal-section">
            <h2>{t.section2Title}</h2>
            <p>{t.section2Intro}</p>
            <ul>
              {t.section2Items.split('|').map((item) => (
                <li key={getStableKey(item, 'section2')}>
                  <strong>{item.split(':')[0]}:</strong> {item.split(':').slice(1).join(':')}
                </li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t.section3Title}</h2>
            <p>{t.section3Intro}</p>
            <ul>
              {t.section3Items.split('|').map((item) => (
                <li key={getStableKey(item, 'section3')}>
                  <strong>{item.split(':')[0]}:</strong> {item.split(':').slice(1).join(':')}
                </li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t.section4Title}</h2>
            <p>{t.section4Intro}</p>
            <ul>
              {t.section4Items.split('|').map((item) => (
                <li key={getStableKey(item, 'section4')}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>{t.section5Title}</h2>
            <p>{t.section5Intro}</p>
            <ul>
              {t.section5Items.split('|').map((item) => (
                <li key={getStableKey(item, 'section5')}>{item}</li>
              ))}
            </ul>
            <p>{t.section5Footer}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section6Title}</h2>
            <p>{t.section6Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section7Title}</h2>
            <p>{t.section7Intro}</p>
            <ul>
              {t.section7Items.split('|').map((item) => (
                <li key={getStableKey(item, 'section7')}>
                  <strong>{item.split(':')[0]}:</strong> {item.split(':').slice(1).join(':')}
                </li>
              ))}
            </ul>
            <p>{t.section7Footer}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section8Title}</h2>
            <p>{t.section8Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section9Title}</h2>
            <p>{t.section9Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section10Title}</h2>
            <p>{t.section10Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section11Title}</h2>
            <p>{t.section11Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section12Title}</h2>
            <p>{t.section12Content}</p>
          </section>

          <section className="legal-section">
            <h2>{t.section13Title}</h2>
            <p>
              {t.section13Content.split('|').map((line) => (
                <React.Fragment key={getStableKey(line, 'section13')}>
                  {line !== t.section13Content.split('|')[0] && <br />}
                  {line}
                </React.Fragment>
              ))}
            </p>
            <p>{t.section13Footer}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
